import { ThunkType } from "../../../../core/store/reducers";
import { getRefPriceReport } from "../api/getRefPriceReport";
import fileDownload from "js-file-download";
import { setDownloadFetchState } from "../tradingDataSlice";

export const downloadRefPriceReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.clearing.tradingData;
  const user = store.data.auth.current.user;

  dispatch(setDownloadFetchState({ type: "started" }));
  const ordersReport = await dispatch(getRefPriceReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "RefPrice.pdf"
    );
  }
  dispatch(setDownloadFetchState({ type: "not-started" }));
};

